import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import * as walletServices from '../walletServices'
import { CreateCryptoAddressWithdrawPayload } from '../walletTypes'

import { QUERY_KEYS } from '@/constants/queryKeys'
import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useCreateWithdrawCryptoAddress = (
  options?: IOptionsUseMutation<CreateCryptoAddressWithdrawPayload>,
) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation<
    CreateCryptoAddressWithdrawPayload,
    ErrorDetail,
    CreateCryptoAddressWithdrawPayload
  >({
    mutationFn: walletServices.createWithdrawCryptoAddress,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.WITHDRAW_CRYPTO_ADDRESSES],
      })

      if (options?.onSuccess) {
        options.onSuccess(variables)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)

      let errorMessage = 'api:errors.somethingWrong'

      if (code === ApiErrorCode.INVALID_CRYPTO_ADDRESS_ERROR) {
        errorMessage = 'api:errors.pleaseUseAnotherAddress'
      }

      if (code === ApiErrorCode.CRYPTO_ADDRESS_ALREADY_EXISTS_ERROR) {
        errorMessage = 'api:errors.addressAlreadyExists'
      }

      if (options?.onError)
        options?.onError({ ...err, errorMessage: t(errorMessage), code })
    },
  })
}
